import * as goldenrush from './SRMInfo.styles.goldenrush';
import * as juicybet from './SRMInfo.styles.juicybet';
import * as vikingbet from './SRMInfo.styles.vikingbet';
import * as betprofessor from './SRMInfo.styles.betprofessor';
import * as fiestabet from './SRMInfo.styles.fiestabet';
import * as junglebet from './SRMInfo.styles.junglebet';
import * as puntcity from './SRMInfo.styles.puntcity';
import * as sterlingparker from './SRMInfo.styles.sterlingparker';
import * as puntgenie from './SRMInfo.styles.puntgenie';
import * as volcanobet from './SRMInfo.styles.volcanobet';
import * as wellbet from './SRMInfo.styles.wellbet';
import * as betroyale from './SRMInfo.styles.betroyale';
import * as betgalaxy from './SRMInfo.styles.betgalaxy';
import * as oldgill from './SRMInfo.styles.oldgill';
import * as questbet from './SRMInfo.styles.questbet';
import * as sugarcastle from './SRMInfo.styles.sugarcastle';
import * as buffalobet from './SRMInfo.styles.buffalobet';
import * as titanbet from './SRMInfo.styles.titanbet';
import * as slambet from './SRMInfo.styles.slambet';
import * as gigabet from './SRMInfo.styles.gigabet';
import * as betstride from './SRMInfo.styles.betstride';
import * as goldenbet888 from './SRMInfo.styles.goldenbet888';
import * as chromabet from './SRMInfo.styles.chromabet';
import * as templebet from './SRMInfo.styles.templebet';
import * as hyperbet from './SRMInfo.styles.hyperbet';
import * as bet777 from './SRMInfo.styles.bet777';
import * as bet575 from './SRMInfo.styles.bet575';
import * as betblast from './SRMInfo.styles.betblast';
import * as pyramidbet from './SRMInfo.styles.pyramidbet';
import * as magnumbet from './SRMInfo.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  buffalobet,
  questbet,
  goldenrush,
  juicybet,
  vikingbet,
  betprofessor,
  fiestabet,
  junglebet,
  puntcity,
  sterlingparker,
  puntgenie,
  volcanobet,
  wellbet,
  betroyale,
  betgalaxy,
  oldgill,
  sugarcastle,
  titanbet,
  slambet,
  gigabet,
  betstride,
  goldenbet888,
  chromabet,
  templebet,
  hyperbet,
  bet777,
  bet575,
  betblast,
  pyramidbet,
  magnumbet,
};
